import { IGlobalReducer } from "./reducers";
import { moduleReducersToWriteToStorage } from "../modules/reducers";

export const DRIVE_STORAGE_PREFIX = "geotabDrive_";
export const DRIVE_REDUX_PREFIX = "@store_";

export const getFullReducerStorageKey = (reducer: keyof IGlobalReducer | keyof typeof moduleReducersToWriteToStorage): string => {
    return `${ DRIVE_STORAGE_PREFIX + DRIVE_REDUX_PREFIX + reducer }`;
};
